import { useState } from "react";
import { useTranslation } from 'react-i18next';
import SimpleHeader from "../../components/layout/SimpleHeader";
import TabItem from "../../components/statistics/TabItem";
import Day from "./app-day";
import Student from "./app-student";

export enum AppContents {
  Day,
  Student
}

const StatisticsApp = () => {
  const { t } = useTranslation();
  const [content, setContent] = useState<AppContents>(AppContents.Day);

  const renderContent = () => {
    switch (content) {
      case AppContents.Day:
        return <Day />;
      case AppContents.Student:
        return <Student />;
    }
  }

  return (
    <>
    <SimpleHeader
      iconFile="icon-statistics-big.svg"
      parentMenu={t('common.menu.statistics')}
      currentMenu={t('statistics.app.title1')}
      onlyTitle={true}
    />

    <div className="content scrollbar">
      <div className="col-frame">
        <div className="comm-tab__line">
          <ul>
            <TabItem
              currentContent={content}
              onSetContent={setContent}
              tabContent={AppContents.Day}
              tabLabel={t('statistics.appDay.1')}
            />
            <TabItem
              currentContent={content}
              onSetContent={setContent}
              tabContent={AppContents.Student}
              tabLabel={t('statistics.appstudent.title1')}
            />
          </ul>
        </div>
        <div>
          {renderContent()}
        </div>
      </div>
    </div>
    </>
  );
}

export default StatisticsApp;
